export const PLAYER_STATUS_EFFECT_DAMAGE = {
  copy: 'You take %1 damage from your %2',
  direction: 'outbound',
};

export const PLAYER_STATUS_EFFECT_DISABLED = {
  copy: 'You are %1 and unable to move',
  direction: 'outbound',
};

export const CREATURE_STATUS_EFFECT_DAMAGE = {
  copy: 'Enemy %1 takes %2 damage from its %3',
  direction: 'outbound',
};

export const CREATURE_STATUS_EFFECT_DISABLED = {
  copy: 'Enemy %1 is %2 and unable to move',
  direction: 'outbound',
};
